const moduleName = 'forms';

export function forms() {
    document.querySelectorAll('input.js-dep-placeholder').forEach((input) => {
        input.addEventListener('change', function (){
            const placeholder = this.dataset.depPlaceholder;
            const depInput = document.querySelector(`#${this.dataset.depId}`);
            if(this.checked){
                depInput.placeholder = placeholder;
            }
        });
    });
}
